import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_MODEL_BLOG_URL } from '../customModel/schema';

const QUERY = gql`
  query performanceCenterGetCustomModelBlogUrl($id: ID!) {
    performanceCenterGetCustomModelBlogUrl(id: $id) {
      ...CustomModelBlogUrl
    }
  }
  ${FRAGMENT_CUSTOM_MODEL_BLOG_URL}
`;

export const performanceCenterGetCustomModelBlogUrl = (id) => {
  return executeGqlQuery({
    query: QUERY,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
};
